import { GridActionsCellItem } from '@mui/x-data-grid';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

import DeleteModal from '@Components/Modal/DeleteModal';
import { useDisclosure } from '@hooks/useDisclosure';
import { GoalActionProps } from './GoalAction';
import { useGoalAndOperationalPlansForm } from '@Router/GoalAndOperationalPlans/Containers/GoalAndOperationalPlansFormProvider';
import { useWatch } from 'react-hook-form';

const GoalDeleteButton = ({ rowId, planIndex }: GoalActionProps) => {
  const [opened, { open, close }] = useDisclosure();
  const { getValues, setValue } = useGoalAndOperationalPlansForm();
  const completedSection = useWatch({
    name: 'completedSection',
  });

  const { isCompletedTh, isCompletedEn } = completedSection ?? {};

  const handleDelete = () => {
    const prevPlans = getValues(
      `companyValueIncreasePlans.valueUpPlans.${planIndex}.goals`
    );
    const updatedPlans = prevPlans?.filter((_, index) => index !== rowId);

    setValue(
      `companyValueIncreasePlans.valueUpPlans.${planIndex}.goals`,
      updatedPlans
    );
    close();
  };

  return (
    <>
      <GridActionsCellItem
        key="delete"
        icon={<DeleteOutlineIcon style={{ fontSize: '16px' }} />}
        label="Delete"
        onClick={open}
        disabled={isCompletedTh || isCompletedEn}
      />
      <DeleteModal
        topic={`แผนการดำเนินงาน`}
        opened={opened}
        close={close}
        confirm={handleDelete}
      />
    </>
  );
};

export default GoalDeleteButton;
